export const partialPercentage = (price_old: number, price_new: number) => {
  const discountAmount = price_old - price_new;
  const discountPercentage = (discountAmount / price_old) * 100;
  return discountPercentage.toFixed(0);
};
